import FlavourSelection from "./FlavourSelection";
export default FlavourSelection;